import { H4Semi } from 'components/common/typography'
import { TransparentButton } from 'components/common/common_styles'
import { MenuContainer } from './bookingWidgetMobileDropdownMenu_styles'

const BookingWidgetMobileDropdownMenu = ({ title, onClose }) =>
  <MenuContainer>
    <TransparentButton onClick={onClose}>✕</TransparentButton>
    <H4Semi>{title}</H4Semi>
  </MenuContainer>

export default BookingWidgetMobileDropdownMenu
